import { gql } from '@apollo/client'

/**
 * Stock of every product a combo or complex promotion names, for deciding
 * whether its "add all" button can be fulfilled.
 *
 * Calls `searchProduct` by `skus`, which the resolver answers with hidden
 * products included and the tenant's stock configuration applied. Selects
 * only what the availability check reads, and deliberately does not
 * interpolate `promotionsFieldsQuery`: that fragment is shared by many
 * documents (catalog, search, product, cart), so a field added to it would be
 * requested — and stale every fixture — on all of them. The one field this
 * needs that the fragment lacks is `productPackage` on the group items, which
 * is why the promotions are re-read here rather than taken from the page's
 * product; quantities and group types are read from the page's own copy.
 * @internal
 */
const promotionItemsAvailabilityQuery = gql`
  query promotionItemsAvailability(
    $storefrontName: String!
    $sessionId: String!
    $skus: [String]
  ) {
    searchProduct(
      storefrontName: $storefrontName
      sessionUid: $sessionId
      skus: $skus
    ) {
      sku
      name
      stock
      outOfStock
      extraPackages {
        name
        stock
      }
      bundle {
        items
      }
      promotions {
        id
        customerBuys {
          groups {
            identifier
            items {
              sku
              productPackage
            }
          }
        }
        customerGets {
          groups {
            identifier
            items {
              sku
              productPackage
            }
          }
        }
      }
    }
  }
`

export default promotionItemsAvailabilityQuery
